import React, { Component } from "react";
import Updatehonours from "./updatehonours";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import Popup from "../../../../common/popup";

import DateFns from "date-fns";

/**
 * Honours and awards Component for displaying the user honours and award details.
 */
class Honours extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      updateData: null,
      deletePopupId :"",
      validid: false,
      isOpen: false,
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
    this.deleteAward = this.deleteAward.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
   
  }

//  close add form
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }

  // open update form
  openUpdateForm(detail) {
    console.log(detail);
    this.setState({
      updateData: detail,
      updateBtn: true,
    });
  }

  //  open add form
  openAddForm(detail) {
    console.log(detail);
    this.setState({
      updateData: null,
      updateBtn: true,
    });
  }
  // toggle delete popup
  togglePopup(detail) {
    this.setState({
      isOpen: !this.state.isOpen,
      deletePopupId: detail
    });
  }

  // close update form
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.getData();
  }

  componentDidMount() {
    this.getData();
  }

  // get all candidate award detail
  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-award`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // delete award function

  deleteAward(obj) {
    console.log("chandra", obj);

    if (this.state.data === undefined) {
      return;
    }
   

    let body = {
      id: obj,
    };

    console.log(body);

    axios
      .delete(`${API_CANDIDATE}/v1/api/can-award`, {
        withCredentials: true,
        data: body,
      })
      .then((res) => {
        console.log(res);
        if (res.data.ok) {
          this.getData();
          this.setState({
            isOpen: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  

  render() {
    console.log(this.state.data);
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
        {!addBtn && !updateBtn ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="details-flex-main-div"
            >
              <div style={{ paddingTop: "20px", height: "60px" }}>
                <h5 style={{ fontWeight: "500",fontSize:"1.25rem" }}>Honors And Awards</h5>
              </div>
              <Button
                onClick={this.openAddForm}
                type="submit"
                style={{
                  background: "green",
                  marginTop: "10px",
                  color: "white",
                }}
                className="btn login-button white-text"
              >
                ADD
              </Button>
            </div>

            {this.state.data.map((detail) => (
              <div
                key={detail.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  background: "#FFE8",
                  marginBottom: "30px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingLeft: "2rem",
                    paddingBottom: "15px",
                    width: "100%",
                    marginTop: "20px",
                    borderRadius: "15px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{ fontWeight: "500", fontSize:"0.875rem", flexBasis: "10rem" }}>
                      Award Name
                    </span>
                    <span style={{ fontWeight: "bold", width: "20px" }}>:</span>
                    <span style={{flex: 8,fontWeight: "400", fontSize:"0.75rem" }}>
                      {detail.awardName}
                    </span>
                  </div>
                  <div
                    style={{
                    
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{ fontWeight: "500", fontSize:"0.875rem", flexBasis: "10rem"}}>
                      Award By
                    </span>
                    <span style={{ fontWeight: "bold", width: "20px" }}>:</span>
                    <span style={{ flex: 8,fontWeight: "400", fontSize:"0.75rem" }}>
                      {detail.awardedBy}
                    </span>
                  </div>

                  <div
                    style={{
                    
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{ fontWeight: "500", fontSize:"0.875rem", flexBasis: "10rem"}}>
                      Date Awarded
                    </span>
                    <span style={{ fontWeight: "bold", width: "20px" }}>:</span>
                    <span style={{  flex: 8,fontWeight: "00", fontSize:"0.75rem" }}>
                    
                      { detail.dateAwarded ?
                             DateFns.format(
                              detail.dateAwarded ,
                                "DD-MM-YYYY"
                              )
                            : ""}
                     
                    </span>
                  </div>
                  <div
                    style={{
                     
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1.5rem",
                    }}
                  >
                    <span style={{ fontWeight: "500", fontSize:"0.875rem", flexBasis: "10rem" }}>
                      Remarks
                    </span>
                    <span style={{ fontWeight: "bold", width: "20px" }}>:</span>
                    <span style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem" }}>
                      {detail.remarks}
                    </span>
                  </div>
                </div>

                <div>
                  <i
                    style={{ color: "green", marginRight: "10px" }}
                    className="material-icons pointer edit-btn"
                    onClick={() => this.openUpdateForm(detail)}
                  >
                    edit
                  </i>

                  <i
                    style={{ color: "red" }}
                    onClick={() => this.togglePopup(detail)}
                    className="material-icons pointer contact-delete-btn"
                  >
                    delete
                  </i>
                </div>

                {this.state.isOpen && (
                  <Popup
                    isOpenModal={this.togglePopup}
                    isOnDelete={this.deleteAward}
                    detail={this.state.deletePopupId}
                  />
                )}
              </div>
            ))}
          </>
        ) : null}
        {updateBtn && (
          <Updatehonours
            back={this.closeUpdateForm}
            updateDataProp={this.state.updateData}
            data={data}
          />
        )}
      </>
    );
  }
}

export default Honours;
